import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import Navbar from "../components/market/desktop/Navbar";
import 'rsuite/dist/rsuite.min.css'
// import 'rsuite/styles/index.less';//'rsuite/dist/rsuite.min.css'
import { Table } from 'rsuite';


const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
  }
`;

const Title = styled.div`
    font-family: JetBrains Mono;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
`;

const Container = styled.div`
  padding-left: 75px;
  padding-right: 75px;
`;

const CalendarWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;    
`;


const CalendarTab = styled.div`
    font-family: JetBrains Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    padding: 4px 12px;
    background: ${props => props.active ? "#CCFF3D" : "#161616"};
    color: ${props => props.active ? "rgba(22, 22, 22, 1)" : "#fff"};
    border-right: 1px solid black;
`;

export default function MarketHomePage(props) {
    const [data, setData] = useState([]);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState(0);

    const getData = () => {
      if (sortColumn && sortType) {
        return data.sort((a, b) => {
          let x = a[sortColumn];
          let y = b[sortColumn];
          if (typeof x === 'string') {
            x = x.charCodeAt();
          }
          if (typeof y === 'string') {
            y = y.charCodeAt();
          }
          if (sortType === 'asc') {
            return x - y;
          } else {
            return y - x;
          }
        });
      }
      return data;
    };

    const handleSortColumn = (sortColumn, sortType) => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setSortColumn(sortColumn);
        setSortType(sortType);
      }, 500);
    };

  

  const Card = ({item}) => {
    const image = '';
      return (
       <>
        <div style={{margin: 8, borderRadius: 8}}>
            <div style={{background: `url('${image})`}}>

            </div>
            
        </div>
       </>
      );
  };

  const cards = data.map((item, index) => {
      return <Card key={`card-${index}`} item={item}/>
  })

  return (
    <>      
      <Mobile style={{padding: 8}}>
        {cards}
      </Mobile>
      <Desktop>
        <Navbar/>
        <Container>
          <Title>Find the best <span style={{marginRight: 12, marginLeft: 12, color: '#CCFF3D'}}> NFT & Play2Earn</span> games</Title>

          <CalendarWrapper>
            <CalendarTab
              className="hover"
              active={activeTab == 0}
              onClick={() => setActiveTab(0)}
            >
              24h
            </CalendarTab>
            <CalendarTab
              className="hover"
              active={activeTab == 1}
              onClick={() => setActiveTab(1)}
            >
              1w
            </CalendarTab>
            <CalendarTab 
              className="hover"
              active={activeTab == 2}
              onClick={() => setActiveTab(2)}
            >
              1m
            </CalendarTab>
            <CalendarTab
              className="hover"
              active={activeTab == 3}
              onClick={() => setActiveTab(3)}
            >
              3m
            </CalendarTab>
            <CalendarTab
              className="hover"
              active={activeTab == 4}
              onClick={() => setActiveTab(4)}
            >
              1y
            </CalendarTab>
            <CalendarTab
              className="hover"
              active={activeTab == 5}
              onClick={() => setActiveTab(5)}
            >
              all
            </CalendarTab>
          </CalendarWrapper>
          <Table
            className="rs-theme-dark"
            height={420}
            data={getData()}
            sortColumn={sortColumn}
            sortType={sortType}
            onSortColumn={handleSortColumn}
            loading={loading}
            onRowClick={data => {
              console.log(data);
            }}
           
          >
            <Table.Column flexGrow={1} align="center" fixed sortable>
              <Table.HeaderCell>
                GAME
              </Table.HeaderCell>
              <Table.Cell dataKey="game" />
            </Table.Column>

            <Table.Column width={50} fixed>
              <Table.HeaderCell style={{color:"#fff"}}>NFT</Table.HeaderCell>
              <Table.Cell dataKey="NFT" />
            </Table.Column>

            <Table.Column flexGrow={1} fixed sortable>
              <Table.HeaderCell>FLOOR</Table.HeaderCell>
              <Table.Cell dataKey="floor" />
            </Table.Column>

            <Table.Column width={130} sortable>
              <Table.HeaderCell>VOLUME</Table.HeaderCell>
              <Table.Cell dataKey="volume" />
            </Table.Column>

            <Table.Column width={200} sortable style={{borderRight: '1px solid rgb(255,255,255,0.05)'}}>
              <Table.HeaderCell>SUPPLY</Table.HeaderCell>
              <Table.Cell dataKey="supply" />
            </Table.Column>

            <Table.Column width={200} sortable>
              <Table.HeaderCell>TOKEN</Table.HeaderCell>
              <Table.Cell dataKey="token" />
            </Table.Column>

            <Table.Column width={200} sortable>
              <Table.HeaderCell>PRICE</Table.HeaderCell>
              <Table.Cell dataKey="price" />
            </Table.Column>

            <Table.Column width={200} sortable>
              <Table.HeaderCell>VOLUME</Table.HeaderCell>
              <Table.Cell dataKey="volume" />
            </Table.Column>

            <Table.Column width={200} sortable>
              <Table.HeaderCell>SUPPLY</Table.HeaderCell>
              <Table.Cell dataKey="supply" />
            </Table.Column>

            <Table.Column width={200} sortable>
              <Table.HeaderCell>MKT CAP</Table.HeaderCell>
              <Table.Cell dataKey="mktcap" />
            </Table.Column>

            <Table.Column width={200} sortable>
              <Table.HeaderCell>RATING</Table.HeaderCell>
              <Table.Cell dataKey="rating" />
            </Table.Column>
          </Table>
        </Container>        
      </Desktop>
    </>
  );
}

